export default function postDiscountReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'CREATE_DISCOUNT_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'CREATE_DISCOUNT_ERROR':
      return {...state, ...{error: action.error}};

    case 'CREATE_DISCOUNT_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}